import { ExperienceId } from "redmond";
import dayjs from "dayjs";
import { History } from "history";
import { PATH_AVAILABILITY, PATH_HOME } from "./paths";

export const transformToStringifiedAvailabilityQuery = (
  locationLabel: string,
  fromDate: Date | null,
  untilDate: Date | null
): string => {
  let query = `?locationName=${encodeURIComponent(locationLabel)}`;

  if (fromDate) {
    const formatFrom = dayjs(fromDate).format("YYYY-MM-DD");
    query += `&fromDate=${formatFrom}`;
  }

  if (untilDate) {
    const formatUntil = dayjs(untilDate).format("YYYY-MM-DD");
    query += `&untilDate=${formatUntil}`;
  }

  return query;
};

export const transformToStringifiedShopQuery = (
  experienceId: ExperienceId,
  fromDate: Date | null,
  untilDate: Date | null,
  locationLabel?: string | null
): string => {
  const experienceIdString = encodeURIComponent(experienceId.value);

  let query = `?activityId=${experienceIdString}`;

  if (fromDate) {
    const formatFrom = dayjs(fromDate).format("YYYY-MM-DD");
    query += `&fromDate=${formatFrom}`;
  }

  if (untilDate) {
    const formatUntil = dayjs(untilDate).format("YYYY-MM-DD");
    query += `&untilDate=${formatUntil}`;
  }

  if (locationLabel) {
    query += `&locationName=${encodeURIComponent(locationLabel)}`;
  }

  return query;
};

export const goToAvailability = ({
  history,
  locationLabel,
  fromDate,
  untilDate,
}: {
  history: History;
  locationLabel: string | null;
  fromDate: Date | null;
  untilDate: Date | null;
}) => {
  if (!locationLabel || !fromDate || !untilDate) {
    return history.push(PATH_HOME);
  }

  return history.push(
    `${PATH_AVAILABILITY}${transformToStringifiedAvailabilityQuery(
      locationLabel,
      fromDate,
      untilDate
    )}`
  );
};
